import { MaterialUICore } from '@iclinic/design-system';

import { SectionCard } from '../Common.styles';

const { styled } = MaterialUICore;

export const Card = styled(SectionCard)({
  flex: 1,
});
